import { registerComponent } from "helpers";
import { WYATTPreferredStores } from "wyatt";

registerComponent(
  "preferred-store-name",
  class PreferredStoreName extends WYATTPreferredStores {
    constructor() {
      super();

      this.name = this.querySelector("[data-name]");

      this.update();
    }

    update() {
      if (!this.preferredStoreID) {
        return;
      }

      const preferredStore = WYATT.shopify.stores.find(
        ({ id }) => id === this.preferredStoreID,
      );

      this.name.textContent = preferredStore.name;
    }
  },
);
